import MuiSkeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const Skeleton = (): JSX.Element => (
  <Stack gap={1} role="progressbar" aria-label="Loading content skeleton">
    <MuiSkeleton variant="rounded" height={40} />

    <Stack my={1} gap={1}>
      {[...Array(5)].map((_, index) => (
        <Stack key={index} direction="row" gap={1}>
          <MuiSkeleton variant="rounded" height={30} sx={{ flex: 2 }} />
          <MuiSkeleton variant="rounded" height={30} sx={{ flex: 8 }} />
        </Stack>
      ))}
    </Stack>

    <MuiSkeleton variant="rounded" height={80} />
  </Stack>
);

export default Skeleton;
